import { render, staticRenderFns } from "./MarketplaceAssignUser.vue?vue&type=template&id=6c049a2c&"
import script from "./MarketplaceAssignUser.vue?vue&type=script&lang=js&"
export * from "./MarketplaceAssignUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports